/* Mirrored in gleamery-shopify/assets/calendly_tracking.js. Keep both copies identical. */
(function (window, document) {
  "use strict";

  if (window.gleameryCalendlyTracking) return;

  var VERSION = "1";
  var PREFIX = "rk_session_id:";
  var FIELDS = ["source", "medium", "campaign", "content", "term"];
  var surface =
    window.gleameryAnalyticsIdentityBridgeConfig?.surface === "booking_flow" ? "booking_app" : "storefront";
  var attribution;
  var links = new Map();
  var disposed = false;
  var refreshQueued = false;

  function consented() {
    return window.gleameryConsent?.hasCategory("analytics") === true;
  }

  function calendlyUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      return url.protocol === "https:" && ["calendly.com", "www.calendly.com"].includes(url.hostname)
        ? url
        : undefined;
    } catch {
      return undefined;
    }
  }

  function snapshot(value) {
    var result = {};
    FIELDS.forEach(function (field) {
      if (typeof value?.[field] === "string" && value[field]) result[field] = value[field];
    });
    return result;
  }

  function cookieSnapshot(name) {
    try {
      var prefix = name + "=";
      var cookie = document.cookie.split(";").find(function (part) {
        return part.trim().startsWith(prefix);
      });
      var result = {};
      decodeURIComponent(cookie ? cookie.trim().slice(prefix.length) : "")
        .split("|")
        .forEach(function (pair) {
          var separator = pair.indexOf("=");
          if (separator < 0) return;
          var value = pair.slice(separator + 1);
          if (value && value !== "null" && value !== "undefined") result[pair.slice(0, separator)] = value;
        });
      return snapshot(result);
    } catch {
      return {};
    }
  }

  // Same source/medium precedence as booking's getUrlTrackingValues. This reads
  // existing attribution; it never stores Calendly's reserved content as marketing attribution.
  function currentTouch() {
    var params = new URL(window.location.href).searchParams;
    var touch = {};
    FIELDS.forEach(function (field) {
      if (params.get("utm_" + field)) touch[field] = params.get("utm_" + field);
    });
    var referrer = document.referrer;
    try {
      var hostname = new URL(referrer).hostname.toLowerCase();
      if (
        ["thegleamery.com", "gleamery.com"].some(function (domain) {
          return hostname === domain || hostname.endsWith("." + domain);
        })
      )
        referrer = "";
    } catch {
      referrer = "";
    }
    if (!touch.source && referrer) {
      if (referrer.includes(".google.")) touch.source = "google";
      else if (referrer.includes(".bing.")) touch.source = "bing";
      else if (referrer.includes("yahoo.")) touch.source = "yahoo";
      else if (referrer.includes("linkedin")) touch.source = "linkedin";
      else if (referrer.includes("facebook")) touch.source = "facebook";
      else if (/twitter|\/\/t\.co|\/\/x\.com/.test(referrer)) touch.source = "twitter";
      else touch.source = referrer;
    }
    if (!touch.medium && referrer) {
      if (/google\.c|bing\.|yahoo\.c|duckduckgo/.test(referrer)) touch.medium = "organic";
      else if (/linkedin|facebook|twitter|\/\/t\.co|\/\/x\.com/.test(referrer)) touch.medium = "social";
      else touch.medium = "referral";
    }
    if (params.get("gclid") || params.get("gbraid") || params.get("wbraid")) {
      touch.source = "google";
      touch.medium = "cpc";
    }
    if (params.get("fbclid")) {
      touch.source = "facebook";
      touch.medium = "social";
    }
    return touch;
  }

  function getAttribution() {
    if (attribution) return attribution;
    var current = currentTouch();
    var first = cookieSnapshot("analytics_first_touch");
    return {
      firstTouch: Object.keys(first).length ? first : current,
      lastTouch: Object.keys(current).length ? current : cookieSnapshot("analytics_last_touch"),
    };
  }

  function prepare(value) {
    var url = calendlyUrl(value);
    if (!url || !consented()) return { url: value };
    try {
      var sessionId = window.gleameryAnalyticsIdentityBridge?.getIdentifiers().rk_session_id;
      if (!sessionId && typeof window.getRKSessionId === "function") sessionId = window.getRKSessionId();
      if (typeof sessionId !== "string" || !/^[A-Za-z0-9_-]{1,128}$/.test(sessionId)) return { url: value };
      var context = getAttribution();
      var lastTouch = snapshot(context.lastTouch);
      if (Object.keys(lastTouch).length) {
        FIELDS.forEach(function (field) {
          url.searchParams.delete("utm_" + field);
          if (lastTouch[field]) url.searchParams.set("utm_" + field, lastTouch[field]);
        });
      }
      url.searchParams.set("utm_content", PREFIX + sessionId);
      return { url: url.toString(), sessionId: sessionId, context: context };
    } catch {
      // Storage, vendor scripts, or tracking must never make scheduling unavailable.
      return { url: value };
    }
  }

  function record(prepared, linkId) {
    if (!prepared.sessionId || !consented()) return;
    try {
      var destination = new URL(prepared.url);
      window.analytics?.track("Calendly Link Clicked", {
        rk_session_id: prepared.sessionId,
        calendly_tracking_version: VERSION,
        clicked_at: new Date().toISOString(),
        source_surface: surface,
        page_hostname: window.location.hostname,
        page_path: window.location.pathname,
        destination_hostname: destination.hostname,
        destination_path: destination.pathname,
        link_id: linkId || undefined,
        first_touch: snapshot(prepared.context.firstTouch),
        last_touch: snapshot(prepared.context.lastTouch),
      });
    } catch {
      // A failed analytics queue must not interrupt the user's navigation.
    }
  }

  function updateLink(link) {
    var href = link.getAttribute("href");
    var entry = links.get(link);
    var original = entry && href === entry.rendered ? entry.original : href;
    if (!original || !calendlyUrl(original)) {
      links.delete(link);
      return undefined;
    }
    var prepared = prepare(original);
    links.set(link, { original: original, rendered: prepared.url });
    if (href !== prepared.url) link.setAttribute("href", prepared.url);
    return prepared;
  }

  function refresh() {
    if (disposed) return;
    links.forEach(function (_entry, link) {
      if (!link.isConnected) links.delete(link);
    });
    document.querySelectorAll("a[href]").forEach(updateLink);
  }

  function queueRefresh() {
    if (refreshQueued || disposed) return;
    refreshQueued = true;
    window.queueMicrotask(function () {
      refreshQueued = false;
      refresh();
    });
  }

  function activate(event) {
    if (event.defaultPrevented || (event.type === "click" ? event.button !== 0 : event.button !== 1)) return;
    var link = event.target instanceof window.Element ? event.target.closest("a[href]") : undefined;
    if (!link) return;
    var prepared = updateLink(link);
    if (prepared) {
      var section = link.closest("[id^='shopify-section-']");
      record(prepared, link.dataset.calendlyLinkId || link.id || section?.id);
    }
  }

  var observer = new window.MutationObserver(queueRefresh);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href"],
  });
  document.addEventListener("click", activate, true);
  document.addEventListener("auxclick", activate, true);

  window.gleameryCalendlyTracking = {
    version: VERSION,
    isCalendlyUrl: function (value) {
      return Boolean(calendlyUrl(value));
    },
    decorateUrl: function (value) {
      return prepare(value).url;
    },
    prepareNavigation: function (value, linkId) {
      var prepared = prepare(value);
      record(prepared, linkId);
      return prepared.url;
    },
    setAttribution: function (value) {
      attribution =
        consented() && value
          ? {
              firstTouch: snapshot(value.firstTouch),
              lastTouch: snapshot(value.lastTouch),
            }
          : undefined;
      refresh();
    },
    refresh: refresh,
    destroy: function () {
      disposed = true;
      observer.disconnect();
      document.removeEventListener("click", activate, true);
      document.removeEventListener("auxclick", activate, true);
      links.forEach(function (entry, link) {
        if (link.getAttribute("href") === entry.rendered) link.setAttribute("href", entry.original);
      });
      links.clear();
      attribution = undefined;
    },
  };
  window.gleameryConsent?.onConsentUpdate(function () {
    if (!consented()) attribution = undefined;
    refresh();
  });
  window.gleameryConsent?.onCategory("analytics", refresh);
  refresh();
})(window, document);
